// Also ported to `view/Blocker.php`
export var HTML_ATTRIBUTE_CAPTURE_PREFIX = "consent-original";
export var HTML_ATTRIBUTE_CAPTURE_CLICK_PREFIX = "consent-click-original";
export var HTML_ATTRIBUTE_CAPTURE_SUFFIX = "_";
export var HTML_ATTRIBUTE_BY = "consent-by"; // TODO: cookie -> required?

export var HTML_ATTRIBUTE_COOKIE_IDS = "consent-required";
export var HTML_ATTRIBUTE_VISUAL_PARENT = "consent-visual-use-parent";
export var HTML_ATTRIBUTE_VISUAL_PAINT_MODE = "consent-visual-paint-mode";
export var HTML_ATTRIBUTE_INLINE = "consent-inline";
export var HTML_ATTRIBUTE_INLINE_STYLE = "consent-inline-style";
export var HTML_ATTRIBUTE_BLOCKER_ID = "consent-id";
export var HTML_TAG_CONSENT_SCRIPT = "script";
export var HTML_ATTRIBUTE_BLOCKER_CONNECTED = "consent-blocker-connected";
export var HTML_ATTRIBUTE_BLOCKER_CONNECTED_PRESERVED = "consent-blocker-connected-pres";
export var HTML_ATTRIBUTE_UNBLOCKED_TRANSACTION_COMPLETE = "consent-transaction-complete";
export var HTML_ATTRIBUTE_TRANSFORM_WRAPPER = "consent-transform-wrapper";
export var HTML_ATTRIBUTE_TRANSFORM_WRAPPER_VALUE = "1";
export var HTML_ATTRIBUTE_WAS_PREVIOUSLY_STRICT_HIDDEN = "consent-strict-hidden";
export var HTML_ATTRIBUTE_RESET_PARENT = "consent-cb-reset-parent";
export var HTML_ATTRIBUTE_RESET_PARENT_VALUE = "1";
export var HTML_ATTRIBUTE_RESET_PARENT_IS_RATIO_CONTAINER = "consent-cb-reset-parent-is-ratio";
export var HTML_ATTRIBUTE_GOT_CLICKED = "consent-got-clicked";
export var HTML_ATTRIBUTE_GOT_CLICKED_VALUE = "1";
export var HTML_ATTRIBUTE_GOT_CLICKED_VALUE_DO_NOT_USE_IN_NESTED = "2";
export var HTML_ATTRIBUTE_THUMBNAIL = "consent-thumbnail";
export var HTML_ATTRIBUTE_THUMBNAIL_SUGGESTION = "consent-thumbnail-suggestion";